// extracted by mini-css-extract-plugin
export default {"holdingCardTimer":"Style_holdingCardTimer__Uh7Rd"};